//* Components
import { icons } from './util';

//* Styles
import IconStyle from './style';

const Icon = ({ name, className }) => {
	return (
		<IconStyle className={`icon-container ${className || ''}`}>
			<div className='icon-wrap'>{icons[name]}</div>
		</IconStyle>
	);
};

export default Icon;
